import MobileSignalIcon from "components/layout/status/MobileSignalIcon";

import type { RobotMobileState } from "lib/hooks/useRobotMobileStatus";

type Props = {
    mobile: RobotMobileState;
    className?: string;
};

const MobileSignalStatusBarIcon: React.FC<Props> = ({ mobile, className = "" }) => {
    if (mobile.kind === "loading") {
        return (
            <div className={`inline-flex shrink-0 items-center ${className}`} title="Mobile…">
                <MobileSignalIcon status={0} className="shrink-0" />
            </div>
        );
    }

    if (mobile.kind === "unavailable") {
        return (
            <div
                className={`inline-flex shrink-0 items-center ${className}`}
                title="Mobile status unavailable"
            >
                <MobileSignalIcon status={0} className="shrink-0" />
            </div>
        );
    }

    if (mobile.kind === "disabled") {
        return (
            <div
                className={`inline-flex shrink-0 items-center ${className}`}
                title="Mobile network off"
            >
                <MobileSignalIcon status={0} className="shrink-0" />
            </div>
        );
    }

    const strength = mobile.signal != null ? mobile.signal : 50;

    return (
        <div
            className={`inline-flex shrink-0 items-center ${className}`}
            title={
                mobile.signal != null
                    ? `Mobile signal ${Math.round(mobile.signal)}%`
                    : "Mobile network on"
            }
        >
            <MobileSignalIcon status={strength} className="shrink-0" />
        </div>
    );
};

export default MobileSignalStatusBarIcon;
